import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ViewDetailModal(props) {
    const handleClose = (e) => {
        props.handleClose();
    }

    const scanDetail = props.stateProps.scanDto;


    return (
        <Modal show={props.stateProps.showviewdetailmodal} onHide={handleClose} style={{ opacity: 1, overflowX: 'scroll' }} size="lg"   >
        <Modal.Header closeButton>
            <Modal.Title>Scan details</Modal.Title>
        </Modal.Header>
            <Modal.Body style={{ height: "70vh", width: "100%" }}>
             
                <pre style={{height:"100%"}}>{JSON.stringify(scanDetail, null, 4)}</pre>
           
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Close
            </Button>
        </Modal.Footer>
    </Modal>


    );

}

export default ViewDetailModal;
